// Web Component: MainProduct
// Gestisce la logica della pagina prodotto, inclusi eventi GTM, caricamento dati e interazione con analytics.
// Attributi richiesti: presenza di #product-json
// Dipendenze: Utils, Shopify.analytics, presenza di form e data-gtm-action
// Limiti: richiede struttura HTML compatibile e dati JSON corretti
// Utilizzato nelle pagine prodotto
class MainProduct extends HTMLElement {
  form; loader; productData; 
  static s = {
    checkout: '[data-checkout]'
  }
  constructor() {
    super();
    this.loader = document.querySelector('theme-loader[data-global]');
    this.init();
  }

  connectedCallback() {
    this.productData = JSON.parse(document.querySelector('#product-json')?.innerText).product;
    this.variantData = JSON.parse(document.querySelector("#product-json")?.innerText).variant;
    this.currencyCode = JSON.parse(document.querySelector('#product-json')?.innerText).currencyCode;
    this.querySelectorAll('[data-gtm-action]').forEach(el => {
      el.addEventListener('click', () => {
        const action = el.dataset.gtmAction;
        if(el.classList.contains('collapsed')){
          return;
        }
        //repeated to get the correct variant
        this.variantData = JSON.parse(document.querySelector("#product-json")?.innerText).variant;
        Shopify.analytics.publish(`pdp:interaction`, { productTitle: this.productData.title, variantSKU: this.variantData.sku, action: action });
      });
    });
    Shopify.analytics.publish('product:viewed', { ...this.variantData, product: this.productData, currencyCode: this.currencyCode });
  }

  init = () => {
    this.form = this.querySelector('form');
    this.productData = JSON.parse(this.querySelector('#product-json').innerText);
    this.querySelectorAll(MainProduct.s.checkout).forEach(button => {
      button.addEventListener('click', () => this.purchase());
    });
  }

  apps = () => {
    this.feedaty();
  }

  feedaty = () => {
    const script = document.querySelector('#qa-script');
    if(script){
      const newScript = script.cloneNode();
      script.remove();
      document.body.appendChild(newScript);
    }
    FeedatyWidget.init();
    feedatyQaInit();
  }

  addToCart = () => {
    this.showLoader();
    Utils.addTocart({
      form: this.form,
      finally: () => this.hideLoader()
    });
  }

  purchase = () => {
    this.showLoader();
    Utils.addTocart({
      data: new FormData(this.form),
      success: () => {
        window.location.href = Shopify.routes.root + 'checkout';
      }
    });
  }

  showLoader = () => {
    if(this.loader)
      this.loader.show();
  }

  hideLoader = () => {
    if(this.loader)
      this.loader.hide();
  }
}
if(!customElements.get('main-product')) {
  customElements.define('main-product', MainProduct);
}

class ProductSticky extends HTMLElement {
  static hiddenClasses = ['invisible'];

  connectedCallback() {
    setTimeout(() => this.observe());
  }

  observe = () => {
    if(!this.dataset.observe) {
      console.error('ProductSticky: data-observe attribute is required.');
      return;
    }
    const buttons = document.querySelector(this.dataset.observe);
    if(!buttons) {
      console.error('ProductSticky: observed element not found.', this.dataset.observe);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.hide();
        } else if(entry.boundingClientRect.top < 0) {
          this.show();
        }
      });
    });
    observer.observe(buttons);
  }

  show = () => {
    ProductSticky.hiddenClasses.forEach(className => {
      this.classList.remove(className);
    });
  }

  hide = () => {
    ProductSticky.hiddenClasses.forEach(className => {
      this.classList.add(className);
    });
  }
}
if(!customElements.get('product-sticky')) {
  customElements.define('product-sticky', ProductSticky);
}

// Web Component: StickySizeSelect
// Gestisce apertura/chiusura del selettore taglia della barra sticky.
// - Mobile: bottom sheet con backdrop; Desktop: dropdown ancorato (stile via base.css).
// - Delega i click cosi' i listener sopravvivono al reload-url che rigenera trigger,
//   lista e bottone add al cambio variante.
// Trigger di apertura: .js-size-trigger (toggle) e [data-open-size] (bottone add senza
// taglia scelta). Chiusura: .js-size-close (X e backdrop), Escape, e la selezione di una
// taglia (.js-size-row → variant-changer, che poi ricarica il contenuto aggiornato).
// Quick-add: se il pannello viene aperto dal bottone "Aggiungi al carrello" (intento
// pendingAdd), selezionare una taglia aggiunge direttamente il prodotto al carrello —
// dopo che il reload-url ha rigenerato il <cart-add>, viene attivato via MutationObserver.
// Se il pannello viene aperto manualmente dal selettore, si limita a scegliere e chiudere.
// Vale sia per click sia per selezione da tastiera (Enter/Space) per accessibilita'.
class StickySizeSelect extends HTMLElement {
  static OPEN = 'open';
  static BODY_LOCK = 'sticky-size-open';
  static AUTOADD_TIMEOUT = 5000; // ms: guardia se il <cart-add> non compare dopo il reload

  // Intento con cui e' stato aperto il pannello: true = aperto dal bottone add
  // (→ auto-add alla scelta taglia), false = aperto manualmente dal selettore.
  pendingAdd = false;

  connectedCallback() {
    this.onKeydown = this.onKeydown.bind(this);
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('keydown', this.onRowKeydown.bind(this));
    document.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKeydown);
    document.body.classList.remove(StickySizeSelect.BODY_LOCK);
  }

  onClick = (e) => {
    if(e.target.closest('.js-size-close')) {
      e.preventDefault();
      this.close();
      return;
    }
    if(e.target.closest('.js-size-trigger')) {
      e.preventDefault();
      this.pendingAdd = false; // apertura manuale: nessun auto-add
      this.toggle();
      return;
    }
    if(e.target.closest('[data-open-size]')) {
      e.preventDefault();
      this.pendingAdd = true; // aperto dal bottone add: auto-add alla scelta taglia
      this.open();
      return;
    }
    // Selezione di una taglia: chiudi (variant-changer gestisce il cambio variante).
    if(e.target.closest('.js-size-row')) {
      this.onRowSelected();
    }
  }

  // Selezione taglia da tastiera (Enter/Space): stesso comportamento del click.
  // variant-changer intercetta gia' il keydown per cambiare variante; qui gestiamo
  // solo chiusura + eventuale auto-add.
  onRowKeydown = (e) => {
    if((e.key === 'Enter' || e.key === ' ') && e.target.closest('.js-size-row')) {
      this.onRowSelected();
    }
  }

  // Taglia scelta: leggi l'intento prima di chiudere (close azzera pendingAdd) e,
  // se il pannello era stato aperto dal bottone add, programma l'aggiunta al carrello.
  onRowSelected = () => {
    const wasPendingAdd = this.pendingAdd;
    this.close();
    if(wasPendingAdd) this.scheduleAutoAdd();
  }

  // Attende che il reload-url del bottone add rigeneri il <cart-add> (dopo il cambio
  // variante innescato da variant-changer) e lo attiva, come un click reale.
  scheduleAutoAdd = () => {
    const host = this.querySelector('reload-url[data-section="helper-product-add"]');
    if(!host) return;
    let timeoutId;
    const observer = new MutationObserver((mutations, obs) => {
      const cartAdd = host.querySelector('cart-add');
      if(cartAdd) {
        obs.disconnect();
        clearTimeout(timeoutId);
        cartAdd.click();
      }
    });
    observer.observe(host, { childList: true, subtree: true });
    timeoutId = setTimeout(() => observer.disconnect(), StickySizeSelect.AUTOADD_TIMEOUT);
  }

  onKeydown(e) {
    if(e.key === 'Escape' && this.isOpen()) {
      this.close();
    }
  }

  isOpen = () => this.classList.contains(StickySizeSelect.OPEN);

  toggle = () => {
    this.isOpen() ? this.close() : this.open();
  }

  open = () => {
    this.classList.add(StickySizeSelect.OPEN);
    this.setExpanded(true);
    document.body.classList.add(StickySizeSelect.BODY_LOCK);
  }

  close = () => {
    this.classList.remove(StickySizeSelect.OPEN);
    this.setExpanded(false);
    document.body.classList.remove(StickySizeSelect.BODY_LOCK);
    this.pendingAdd = false;
  }

  setExpanded = (value) => {
    const trigger = this.querySelector('.js-size-trigger');
    if(trigger) {
      trigger.setAttribute('aria-expanded', value ? 'true' : 'false');
    }
  }
}
if(!customElements.get('sticky-size-select')) {
  customElements.define('sticky-size-select', StickySizeSelect);
}

/*
//gestisce il trova in negozio in pp con onestock
class StoreStock extends HTMLElement {

  i18n;     // traduzioni
  province; // la provincia del cliente (sigla)
  zip;      // il cap del cliente 
  stores;   // elenco sedi
  stocks;   // risposta di onestock per la variante
  merged;   // elenco dei negozi con relativa disponibilità
  store;    // id dello store preferito
  unified;  // sede unified dall'elenco merged

  static S = {
    saveProvince: '[data-province-save]',
    provinceInput: '#store-province-input',
    deliveryTitle: '[data-delivery-title]',
    deliveryDescription: '[data-delivery]',
    storeList: '[data-store-list]',
    storeTitle: '[data-store-title]',
    storeInner: '[data-store]',
    storeItem: '[data-store-item]'
  }
  static UNIFIED = 'XY'; // codice dello store unified
  static URLSTORES = `${Utils.API_URL}/api/fidelity/shops`;
  static URLSTOCK = `${Utils.API_URL}/api/shop/${Shopify.shop}/product-stocks-by-sku-codes`;
  static MAP_API = 'AIzaSyDzJfY1o0dk-bSGQPKFiur1uBzt2TjVYRE';

  connectedCallback() {
    this.i18n = JSON.parse(this.dataset.i18n);

    this.addEventListener(Utils.E_STORES, () => {
      this.merge();
    });
    this.addEventListener(Utils.E_STORE_STOCK, () => {
      this.merge();
    });
    this.addEventListener(Utils.E_STORE_MERGED, () => {
      this.getProvince();
      this.showStores();
    });
    this.addEventListener(Utils.E_STORE_PROVINCE, () => {
      this.getStore();
      this.showProvince();
      this.fillZipInput();
    });
    this.addEventListener(Utils.E_STORE_FOUND, () => {
      this.showStore();
    });
    
    this.getStores();
    this.getStocks();
    this.handleProvince();
  }

  // trova la provincia geolocalizzando o controllando se è salvata nel localStorage o se la ha nei dataset
  getProvince = () => {
    this.province = this.dataset.province || localStorage.getItem('province');
    this.zip = this.dataset.zip || localStorage.getItem('zip');
    if(!this.province){
      if(navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          const latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
          this.geocode({ 'latLng': latlng });
        });
      } else {
        console.log('stock error');
      }
      this.getStore();
    } else {
      localStorage.setItem('province', this.province);
      this.dispatchEvent(new CustomEvent(Utils.E_STORE_PROVINCE, { detail: this.province }));
    }
  }

  // trova lo store preferito o lo cerca tra quelli della provincia
  getStore = () => {
    this.store = localStorage.getItem('favourite_shop');
    if(this.store) {
      this.dispatchEvent(new CustomEvent(Utils.E_STORE_FOUND, { detail: this.store }));
    } else if(this.province) {
      this.store = this.stores.find(store => store.address?.provinceCode == this.province)?.shop_id.value;
      if(this.store) {
        localStorage.setItem('favourite_shop', this.store);
      }
      this.dispatchEvent(new CustomEvent(Utils.E_STORE_FOUND, { detail: this.store }));
    }
  }

  // ottiene tutti i negozi o dal sessionStorage o dal server
  getStores = () => {
    this.stores = JSON.parse(sessionStorage.getItem('stores'));
    if(!this.stores) {
      axios({
        url: StoreStock.URLSTORES,
        method: 'get',
        withCredentials: true
      })
      .then((response) => {
        this.stores = response.data;
        sessionStorage.setItem('stores', JSON.stringify(this.stores));
        this.dispatchEvent(new CustomEvent(Utils.E_STORES, { detail: this.stores }));
      }).catch((error) => {
        Utils.errorHandler({
          message: error.message,
          target: 'store-stock',
          error: error,
          type: 'axios'
        });
      });
    } else {
      this.dispatchEvent(new CustomEvent(Utils.E_STORES, { detail: this.stores }));
    }
  }

  // ottiene le disponibilità della variante da onestock e pubblica un evento al success
  getStocks = () => {
    axios({
      url: StoreStock.URLSTOCK,
      method: 'post',
      data: JSON.stringify(this.dataset.sku.split(',')),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then((response) => {
      this.stocks = response.data;
      this.dispatchEvent(new CustomEvent(Utils.E_STORE_STOCK, { detail: this.stocks }));
    }).catch((error) => {
      Utils.errorHandler({
        message: error.message,
        target: 'store-stock',
        error: error,
        type: 'axios'
      });
    });
  }

  // popola l'elenco merged con le disponibilità
  merge = () => {
    if(this.stores && this.stocks) {
      this.merged = this.stores.map(store => {
        const stock = this.stocks.find(stock => stock.storeCode == store.shop_id.value);
        return {
          ...store,
          stock: stock
        }
      });
      this.unified = this.merged.find(store => store.shop_id.value == StoreStock.UNIFIED);
      this.dispatchEvent(new CustomEvent(Utils.E_STORE_MERGED, { detail: this.merged }));
    }
  }

  // mostra la provincia selezionata e la disponibilità di consegna
  showProvince = () => {
    if(this.province && this.unified){
      const deliveryTitle = this.querySelector(StoreStock.S.deliveryTitle);
      if(deliveryTitle){
        deliveryTitle.innerText = this.i18n.delivery_to.replace('{{ province }}', this.zip);
      }
      const deliveryDescription = this.querySelector(StoreStock.S.deliveryDescription);
      if(deliveryDescription){
        const type = this.unified.stock?.quantity > 0 ? (this.unified.stock.quantity < 3 ? 'low-stock' : 'available') : 'unavailable';

        if(type == 'available') {
          this.getDelivery(deliveryDescription);
          return;
        }

        if(type == 'low-stock') {
          this.getDelivery2(deliveryDescription);
          return;
        }

        const template = this.getTemplate(type);
        deliveryDescription.innerHTML = template.innerHTML;
      }
    }
  }

  getDelivery2 = (deliveryDescription) => {
    const json = JSON.parse(this.querySelector('[data-shipping').innerText);
    const template = this.getTemplate('low-stock');
    const filtered = json.filter(r => r.country.toUpperCase() == this.dataset.country && r.min <= r.product_price && r.max >= r.product_price);

    // ORDINA prima Standard, poi Express, poi il resto
    filtered.sort((a, b) => {
      const priority = name => {
        if (name === "Standard") return 0;
        if (name === "Express") return 1;
        return 2;
      };
      return priority(a.name) - priority(b.name);
    });
    
    const deliveries = filtered.map(delivery => {
      return this.calcDelivery(delivery);
    });
    deliveryDescription.innerHTML = template.innerHTML.replaceAll('{delivery}', deliveries.join(''));
  }

  getDelivery = (deliveryDescription) => {
    const json = JSON.parse(this.querySelector('[data-shipping').innerText);
    const template = this.getTemplate('available');
    const filtered = json.filter(r => r.country.toUpperCase() == this.dataset.country && r.min <= r.product_price && r.max >= r.product_price);

    // ORDINA prima Standard, poi Express, poi il resto
    filtered.sort((a, b) => {
      const priority = name => {
        if (name === "Standard") return 0;
        if (name === "Express") return 1;
        return 2;
      };
      return priority(a.name) - priority(b.name);
    });
    
    const deliveries = filtered.map(delivery => {
      return this.calcDelivery(delivery);
    });
    deliveryDescription.innerHTML = template.innerHTML.replaceAll('{delivery}', deliveries.join(''));
  }

  calcDelivery = (delivery) => {
    const template = this.getTemplate('delivery');
    const price = Number(delivery.price);
    const priceString = price > 0 ? Utils.money(price) : this.i18n.stock.free_html;
    const from = this.calcDeliveryDate(delivery.from);
    const to = this.calcDeliveryDate(delivery.to);

    // Mostra solo se il prezzo è "gratis"
    const showPrice = priceString === this.i18n.stock.free_html ? ` (${priceString})` : '';
    
    return template.innerHTML
      .replaceAll('{name}', delivery.name)
      .replaceAll('{from}', from)
      .replaceAll('{to}', to)
      .replaceAll('{price}', showPrice);
  }

  calcDeliveryDate = (days) => {
    let date = new Date();
    let added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();
      if (day !== 0 && day !== 6) { // 0 = Sunday, 6 = Saturday
        added++;
      }
    }
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    return `${day}/${month}`;
  }

  // mostra la disponibilità nello store selezionato
  showStore = () => {
    if(this.merged && this.store){
      console.log('store', this.store);
      const store = this.merged.find(store => store.shop_id.value == this.store);

      const storeTitle = this.querySelector(StoreStock.S.storeTitle);
      const storeInner = this.querySelector(StoreStock.S.storeInner);

      storeTitle.innerText = store.name;
      const template = this.getTemplate('store-stock').innerHTML;
      var onlineTemplate, storeTemplate;

      if(store.stock?.quantity > 0) {
        if(store.stock.quantity >= 2){
          onlineTemplate = this.getTemplate('online-available').innerHTML.replaceAll('{text}', this.i18n.online_store.store_available_html);
          storeTemplate = this.getTemplate('store-available').innerHTML;
        } else{
          onlineTemplate = this.getTemplate('online-available').innerHTML.replaceAll('{text}', this.i18n.online_store.store_low_html);
          storeTemplate = this.getTemplate('store-low').innerHTML;
        }
      } else {
        storeTemplate = this.getTemplate('store-unavailable').innerHTML;
        if(this.unified?.stock.quantity >= 3) {
          onlineTemplate = this.getTemplate('online-available').innerHTML.replaceAll('{text}', this.i18n.online_store.unified_available_html);
        } else if(this.unified?.stock.quantity > 0) {
          onlineTemplate = this.getTemplate('online-low').innerHTML;
        } else {
          onlineTemplate = this.getTemplate('online-unavailable').innerHTML;
        }
      }
      storeInner.innerHTML = template.replaceAll('{online}', onlineTemplate).replaceAll('{store}', storeTemplate);
    }
    

  }

  // mostra i negozi nell'offcanvas e gestisce il click
  showStores = () => {
    if(this.merged) {
      const list = this.querySelector(StoreStock.S.storeList);
      if(list){
        this.merged.filter(store => store.shop_id.value != StoreStock.UNIFIED).forEach(store => {
          const template = this.getTemplate('store-item');
          list.innerHTML += template.innerHTML
            .replaceAll('{id}', store.shop_id.value)
            .replaceAll('{name}', store.name)
            .replaceAll('{address}', `${store.address.address1}<br>${store.address.zip} ${store.address.city} (${store.address.provinceCode})`);
        });
        this.querySelectorAll(StoreStock.S.storeItem).forEach(item => {
          item.addEventListener('click', () => {
            this.store = item.dataset.storeItem;
            localStorage.setItem('favourite_shop', this.store);
            this.dispatchEvent(new CustomEvent(Utils.E_STORE_FOUND, { detail: this.store }));
          });
        });
      }
    }
  }

  // gestisce la input di selezione della provincia
  handleProvince = () => {
    const button = this.querySelector(StoreStock.S.saveProvince);
    button.addEventListener('click', () => {
      const input = this.querySelector(StoreStock.S.provinceInput);
      if(input.value.trim() != this.zip){
        this.geocode({ address: input.value });
      } else {
        this.showError();
      }
      this.dispatchEvent(new CustomEvent(Utils.E_STORE_PROVINCE, { detail: this.province }));
    });
  }

  // geolocalizza in base a data e restituisce la provincia e il cap
  geocode = (data) => {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode(data, (results, status) => {
      if(status === google.maps.GeocoderStatus.OK){
        this.province = results[0].address_components.find(component => {
          return component.types.includes('administrative_area_level_2');
        });
        this.zip = results[0].address_components.find(component => {
          return component.types.includes('postal_code');
        });
        this.province = this.province?.short_name;
        this.zip = this.zip?.short_name;
        if(this.province && this.zip) {
          localStorage.setItem('province', this.province);
          localStorage.setItem('zip', this.zip);
          this.dispatchEvent(new CustomEvent(Utils.E_STORE_PROVINCE, { detail: this.province }));
        } else {
          this.showProvinceError();
        }
      } else {
        this.showProvinceError();
      }
    });
  }

  showProvinceError = () => {
    Utils.errorHandler({
      message: this.i18n.province.error,
      target: 'store-stock',
      type: 'province',
      popup: true
    })
  }

  // ottiene il template che si desidera
  getTemplate = (name) => {
    return this.querySelector(`template[name="${name}"]`);
  }

  // mostra il cap selezionato di default
  fillZipInput = () => {
    const input = this.querySelector(StoreStock.S.provinceInput);
    if(input && this.zip){
      input.value = this.zip;
    }
  }


}
if(!customElements.get('store-stock')) {
  customElements.define('store-stock', StoreStock);
}
*/
class StoqBtn extends HTMLElement {
  productData;

  connectedCallback() {
    this.productData = JSON.parse(document.querySelector('#product-json')?.innerText);
    if(!this.productData || !this.productData.variant || !this.productData.variant.id || !this.productData.product) {
      console.error("StoqBtn: No product data found.");
      return;
    }

    this.addEventListener('click', this.openStoq.bind(this));
  }

  openStoq = () => {
    if(!window._RestockRocket) {
      console.error("StoqBtn: RestockRocket is not loaded.");
      return;
    }
    window._RestockRocket.openModal(this.productData.product, this.productData.variant.id);
    window.dispatchEvent(new CustomEvent(Utils.E_BACKSTOCK));
    Shopify.analytics.publish(Utils.E_BACKSTOCK);
  }
}
if(!customElements.get('stoq-btn')) {
  customElements.define('stoq-btn', StoqBtn);
}

class ReloadUrl extends HTMLElement {

  connectedCallback() {
    this.onQueryChange(this.reload.bind(this));
    if(this.dataset.cart != undefined){
      window.addEventListener(Utils.E_CART_UPDATED, () => this.reload({ url: location.href }));
      window.addEventListener(Utils.E_CART_REMOVED, () => this.reload({ url: location.href }));
      window.addEventListener(Utils.E_CART_ADDED, () => this.reload({ url: location.href }));
    }
  }

  reload = (query) => {
    console.log('ReloadUrl: query changed', query);
    if(!this.dataset.section){
      console.error('ReloadUrl: no section specified in data-section attribute.');
      return;
    }

    this.classList.add('loading');
    const url = new URL(query.url);
    url.searchParams.set('section_id', this.dataset.section);

    axios.get(url.toString()).then((response) => {
      this.reloaded(response, url);
    }).catch((error) => {
      Utils.errorHandler({
        message: error.response?.data?.message || error.message,
        target: 'reload-url',
        error: error,
        type: 'axios'
      });
    }).finally(() => {
      this.classList.remove('loading');
    });
  }

  reloaded = (response, url) => {
    this.innerHTML = response.data;
  }

  onQueryChange(cb) {
    let prev = location.search;

    const notify = () => {
      if (location.search !== prev) {
        const old = prev;
        prev = location.search;
        cb({ oldSearch: old, newSearch: prev, url: location.href });
      }
    };

    // back/forward
    window.addEventListener('popstate', notify);
    // opzionale: se cambi anche il fragment
    window.addEventListener('hashchange', notify);

    // intercetta pushState/replaceState
    const _push = history.pushState;
    history.pushState = function (...args) {
      const ret = _push.apply(this, args);
      notify();
      return ret;
    };
    const _replace = history.replaceState;
    history.replaceState = function (...args) {
      const ret = _replace.apply(this, args);
      notify();
      return ret;
    };

    // funzione di cleanup (se serve rimuovere i listener)
    return () => {
      window.removeEventListener('popstate', notify);
      window.removeEventListener('hashchange', notify);
      history.pushState = _push;
      history.replaceState = _replace;
    };
  }

}
if(!customElements.get('reload-url')) {
  customElements.define('reload-url', ReloadUrl);
}

class VariantChanger extends HTMLElement {
  connectedCallback() {
    setTimeout(() => {
      this.addEventListener('click', this.changeVariant.bind(this));
      this.addEventListener('keydown', (e) => {
        console.log("VariantChanger: keydown event", e);
        if (e.key === 'Enter' || e.key === ' ') {
          this.changeVariant(e);
        }
      });
      try {
        this.productData = JSON.parse(document.querySelector('#product-json')?.innerText)?.product;
        this.variantData = JSON.parse(this.querySelector("[data-describe]")?.innerText)?.variant;
        this.currencyCode = JSON.parse(document.querySelector('#product-json')?.innerText)?.currencyCode;
      } catch (error) {
        console.error('VariantChanger: error parsing product JSON', error);
      }
    });
  }

  changeVariant = (e) => {
    e.preventDefault();
    //Added 11/02/26: publish variant change event for product interest tracking
    Shopify.analytics.publish('product:interest', { ...this.variantData, product: this.productData, currencyCode: this.currencyCode });
    if(!this.dataset.url) {
      console.error('VariantChanger: no URL specified in data-url attribute.');
      return;
    }
    window.history.replaceState({}, '', this.dataset.url);
  }
}
if(!customElements.get('variant-changer')) {
  customElements.define('variant-changer', VariantChanger);
}

class CartAdd extends HTMLElement {
  loading = false;

  connectedCallback() {
    this.addEventListener('click', this.prepare.bind(this));
  }
  
  prepare = () => {
    if(!this.checkAttributes()) return;

    if(this.dataset.formSelector != undefined) {
      setTimeout(() => {
        const form = document.querySelector(this.dataset.formSelector);
        if(!(form instanceof HTMLFormElement)){
          console.error('CartAdd: selected element is not a form.', form);
          return;
        }
        console.log('Aggiunta al carrello tramite form', form);
        this.add(form);
      });
      return;
    }

    const variantId = parseInt(this.dataset.variant);
    const quantity = parseInt(this.dataset.quantity || '1');
    const data = { 
      items: [
        { id: variantId, quantity: quantity }
      ]
    };
    console.log('Aggiunta al carrello via js', data);
    this.add(data);
  }

  add = (data) => {
    if(this.loading) return;
    console.log('Aggiunta al carrello con bottone', data);
    this.loading = true;
    this.classList.add('loading');

    const options = {};
    if(data instanceof HTMLFormElement) {
      options.form = data;
    } else {
      options.data = data;
    }

    Utils.addTocart({
      ...options,
      finally: () => {
        this.loading = false;
        this.classList.remove('loading');
      }
    });
  }

  checkAttributes = () => {
    if(this.dataset.variant == undefined && this.dataset.formSelector == undefined) {
      console.error('CartAdd: either data-variant or data-form-selector attribute must be specified.');
      return false;
    }
    return true;
  }
}
if(!customElements.get('cart-add')) {
  customElements.define('cart-add', CartAdd);
}